<div class="map-view-container">
  <div class="map-edit-mode">
    <label *ngIf="showTitle" class="map-label">
      {{ getTitle() }}
      <span class="error-indication" *ngIf="isRequired()">{{getError()}}</span>
      <div *ngIf="getOptionByKey(attribute,'tooltip')"
           class="popover-info"
           [popover]="getOptionByKey(attribute,'tooltip')"
           placement="right"
           container="body"
           triggers="mouseenter:mouseleave">
        <i class="fa fa-question-circle"></i>
      </div>
    </label>

    <div class="map-wrapper">
      <div #mapContainer
           class="google-map"
           [style.width]="mapWidth"
           [style.height]="mapHeight">
      </div>

      <div class="address-info" *ngIf="locations.length > 0 && showAddressList">
        <div class="info-header">
          <i class="fa fa-map-marker-alt"></i>
          <span>{{ addressInfoHeader }}</span>
        </div>
        <div class="address-list">
          <div *ngFor="let location of locations"
               class="address-item"
               [class.geocoded]="location.isGeocoded"
               [class.not-geocoded]="!location.isGeocoded">
            <div class="address-marker" [style.background-color]="location.color"></div>
            <div class="address-details">
              <div class="address-name">{{ location.name }}</div>
              <div class="address-text">{{ location.address }}</div>
              <div class="geocoding-status" *ngIf="!location.isGeocoded">
                <i class="fa fa-spinner fa-spin"></i>
                <span>Geocodificando...</span>
              </div>
            </div>
          </div>
        </div>
      </div>      

      <div class="no-addresses" *ngIf="locations.length === 0">
        <i class="fa fa-info-circle"></i>
        <span>Nenhum endereço encontrado. Adicione endereços ao processo para visualizá-los no mapa.</span>
      </div>
    </div>

    <div *ngIf="!isServicesInitialized" class="loading-indicator">
      <i class="fa fa-spinner fa-spin"></i>
      <span>Carregando mapa...</span>
    </div>
  </div>
</div>